import axios from 'axios';
import { Alcohol } from './../models/Alcohol';

export function getItems(orderBy: string, order: string): Promise<Alcohol[]> {
    const data: Record<string, string> = {
        action: 'get_nutrition_values_items',
        orderBy: orderBy,
        order: order,
    };

    return axios.get(window.my_ajax_object.ajax_url, { params: data }).then((response) => {
        return response.data.success ? JSON.parse(response.data.data) : [];
    });
}
